import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  nextMeetings: "Next meetings",
  nextMeetingsDescription: "The next 5 meetings, soonest first",
  video: "Video",
  noMeetings: "No upcoming meetings.",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    nextMeetings: "Prochains rendez-vous",
    nextMeetingsDescription: "Les 5 prochains rendez-vous, du plus proche au plus lointain",
    video: "Vidéo",
    noMeetings: "Aucun rendez-vous à venir.",
  },
  es_ES: {
    nextMeetings: "Próximas reuniones",
    nextMeetingsDescription: "Las 5 próximas reuniones, de la más cercana a la más lejana",
    video: "Vídeo",
    noMeetings: "No hay reuniones próximas.",
  },
  pt_BR: {
    nextMeetings: "Próximas reuniões",
    nextMeetingsDescription: "As próximas 5 reuniões, da mais próxima à mais distante",
    video: "Vídeo",
    noMeetings: "Nenhuma reunião agendada.",
  },
  de_DE: {
    nextMeetings: "Nächste Termine",
    nextMeetingsDescription: "Die nächsten 5 Termine, der früheste zuerst",
    video: "Video",
    noMeetings: "Keine anstehenden Termine.",
  },
  it_IT: {
    nextMeetings: "Prossime riunioni",
    nextMeetingsDescription: "Le prossime 5 riunioni, dalla più vicina",
    video: "Video",
    noMeetings: "Nessuna riunione in programma.",
  },
  ar: {
    nextMeetings: "الاجتماعات القادمة",
    nextMeetingsDescription: "الاجتماعات الخمسة القادمة، الأقرب أولًا",
    video: "فيديو",
    noMeetings: "لا توجد اجتماعات قادمة.",
  },
  ja_JP: {
    nextMeetings: "今後の面談",
    nextMeetingsDescription: "直近の面談 5 件（日付の近い順）",
    video: "ビデオ",
    noMeetings: "予定されている面談はありません。",
  },
  hi_IN: {
    nextMeetings: "आगामी मीटिंग",
    nextMeetingsDescription: "अगली 5 मीटिंग, सबसे निकट वाली पहले",
    video: "वीडियो",
    noMeetings: "कोई आगामी मीटिंग नहीं है।",
  },
  zh_CN: {
    nextMeetings: "即将召开的会议",
    nextMeetingsDescription: "接下来的 5 场会议，按时间先后排列",
    video: "视频",
    noMeetings: "没有即将召开的会议。",
  },
  zh_TW: {
    nextMeetings: "即將舉行的會議",
    nextMeetingsDescription: "接下來的 5 場會議，依時間先後排列",
    video: "視訊",
    noMeetings: "沒有即將舉行的會議。",
  },
  nl_NL: {
    nextMeetings: "Komende afspraken",
    nextMeetingsDescription: "De volgende 5 afspraken, eerstvolgende eerst",
    video: "Video",
    noMeetings: "Geen komende afspraken.",
  },
  nb_NO: {
    nextMeetings: "Neste møter",
    nextMeetingsDescription: "De neste 5 møtene, snarest først",
    video: "Video",
    noMeetings: "Ingen kommende møter.",
  },
  sv_SE: {
    nextMeetings: "Kommande möten",
    nextMeetingsDescription: "De 5 närmaste mötena, tidigast först",
    video: "Video",
    noMeetings: "Inga kommande möten.",
  },
  fi_FI: {
    nextMeetings: "Tulevat tapaamiset",
    nextMeetingsDescription: "Seuraavat 5 tapaamista, lähin ensin",
    video: "Video",
    noMeetings: "Ei tulevia tapaamisia.",
  },
  da_DK: {
    nextMeetings: "Kommende møder",
    nextMeetingsDescription: "De næste 5 møder, snarest først",
    video: "Video",
    noMeetings: "Ingen kommende møder.",
  },
  is_IS: {
    nextMeetings: "Næstu fundir",
    nextMeetingsDescription: "Næstu 5 fundir, þeir fyrstu efst",
    video: "Myndfundur",
    noMeetings: "Engir fundir fram undan.",
  },
};
